import React from 'react';

const Logo = ({ size = 'md', showText = true }) => {
  const sizes = {
    sm: { icon: 28, text: 'text-lg' },
    md: { icon: 36, text: 'text-xl' },
    lg: { icon: 48, text: 'text-3xl' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-2.5">
      <div className="relative">
        <svg width={s.icon} height={s.icon} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Outer ring with gradient */}
          <defs>
            <linearGradient id="logoGrad1" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3374ff" />
              <stop offset="0.5" stopColor="#8b5cf6" />
              <stop offset="1" stopColor="#f9603e" />
            </linearGradient>
            <linearGradient id="logoGrad2" x1="12" y1="8" x2="36" y2="40" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3374ff" />
              <stop offset="1" stopColor="#8b5cf6" />
            </linearGradient>
          </defs>
          {/* Background circle */}
          <rect width="48" height="48" rx="14" fill="url(#logoGrad1)" />
          {/* Document shape */}
          <path d="M16 12h10l8 8v16a2 2 0 01-2 2H16a2 2 0 01-2-2V14a2 2 0 012-2z" fill="white" fillOpacity="0.95" />
          {/* Fold corner */}
          <path d="M26 12v6a2 2 0 002 2h6" fill="none" stroke="url(#logoGrad2)" strokeWidth="1.5" strokeLinecap="round" />
          {/* Lines on document */}
          <rect x="18" y="24" width="12" height="1.5" rx="0.75" fill="#3374ff" fillOpacity="0.5" />
          <rect x="18" y="28" width="9" height="1.5" rx="0.75" fill="#8b5cf6" fillOpacity="0.4" />
          <rect x="18" y="32" width="6" height="1.5" rx="0.75" fill="#f9603e" fillOpacity="0.3" />
          {/* Sparkle */}
          <circle cx="38" cy="10" r="3" fill="white" fillOpacity="0.8" />
          <circle cx="38" cy="10" r="1.5" fill="white" />
        </svg>
      </div>
      {showText && (
        <span className={`${s.text} font-bold tracking-tight`}>
          <span className="gradient-text">Docu</span>
          <span style={{ color: 'var(--text-primary)' }}>Verse</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
